import { Component, Injector, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';
import { BasicTextInputComponent } from '../basic-text-input/basic-text-input.component';
import { CheckboxBasicComponent } from '../basic-checkbox/basic-checkbox.component';
import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
import { CoverpathControllerInterface } from '../../../../interfaces/controller/CoverpathControllerInterface';
import { UnsupportedUseCasesService } from '../../../../services/unsupportedUseCases/unsupportedUseCases.service';

@Component({
  moduleId: module.id,
  selector: 'custom-ssn',
  templateUrl: './custom-ssn.component.html',
})
export class CustomSSNComponent extends BaseFormComponent implements OnInit {
  @ViewChild('taxIdInput', { static: true }) taxIdInput: BasicTextInputComponent;

  noTaxIdCheckbox: CheckboxBasicComponent;
  @ViewChild('noTaxIdCheckbox') set noTaxIdCheckboxSetter(element: CheckboxBasicComponent) {
    this.noTaxIdCheckbox = element;
  }

  controller: CoverpathControllerInterface;
  formatterType: string = '';
  taxIdType: string = '';
  use2019Filing: boolean;
  taxIdProp: string = '';
  is2020CoverpathOrMMD: boolean;
  //properties for no ID checkbox
  noTaxId: boolean = false;
  checkboxText: string;
  showCheckbox: boolean;
  noTaxIdShortProp: string = '';
  noTaxIdFullProp: string = '';
  shouldWaitForPiiFetch: boolean = false;

  constructor(
    protected injector: Injector,
    private amorphicService: AmorphicService,
    private unsupportedUseCaseService: UnsupportedUseCasesService,
    cdRef: ChangeDetectorRef
  ) {
    super(injector);

    this.controller = this.amorphicService.controller;
    this.questionItem = this.injector.get('questionItem');
    this.use2019Filing = this.controller.customer.isCoverpath2019MetadataEnabled();
    this.is2020CoverpathOrMMD = this.controller.customer.application.primaryPolicy.is2020CoverpathOrMMD();
    this.checkboxText = this.questionItem.optionalInputLabel;
    this.showCheckbox = !!this.checkboxText;
    this.taxIdProp = this.questionItem.prop.split('.').slice(-1).join();
    if (this.taxIdProp === 'taxId') {
      this.taxIdType = this.is2020CoverpathOrMMD ? 'TIN or EIN' : 'EIN';
    } else {
      this.taxIdType = this.taxIdProp;
    }
    this.noTaxIdShortProp = this.questionItem.optionalInputProperty;
    this.noTaxIdFullProp = this.questionItem.prop
      .replace(this.taxIdProp, this.noTaxIdShortProp)
      .replace('[i]', `[${this.loopIndex}]`);
  }

  async ngOnInit() {
    this.taxIdInput.obfuscationPattern = '••• - •• - ••••';
    this.obfuscationProperty = {
      type: 'SSN',
      prop: this.prop,
      shouldObfuscate: true,
    };
    await super.setupPiiDisplay(this.taxIdInput);
  }

  async trigger(): Promise<void> {
    if (!this.use2019Filing) {
      if (this.noTaxId) {
        const hasSSN = !this.noTaxId;
        await this.validateAndSet(this.questionItem.prop, hasSSN.toString());
        this.clearFields();
      }
      await this.validateAndSet(this.noTaxIdFullProp, this.noTaxId);
    } else {
      this.taxIdInput.updateFromModel();
      this.noTaxIdCheckbox.updateFromModel();
    }
  }

  async showSSN() {
    if (this.taxIdInput.isError) {
      this.taxIdInput.shouldObfuscate = false;
    } else {
      await super.showPii(this.taxIdInput);
    }
  }

  obfuscateSSN() {
    if (this.taxIdInput.isError) {
      this.taxIdInput.shouldObfuscate = false;
    } else {
      super.obfuscatePii(this.taxIdInput);
    }
  }

  resetValue(): void {
    this.clearFields();
    this.noTaxId = false;
  }

  clearFields(): void {
    this.cdRef.detectChanges();
    this.taxIdInput.resetValue();
    this.noTaxId = false;
  }

  updateFromModel(): void {}

  ngOnDestroy() {
    if (this.obfuscatePiiSubscription) {
      this.obfuscatePiiSubscription.unsubscribe();
    }
  }
}
